import * as THREE from 'three';

const getRdmInt = (min, max) => Math.floor(Math.random() * (max-min)) + min;
const getRdmFloat = (min, max) => Math.random() * (max-min) + min;

export class Branch {
    constructor(conf, x,y,z, st_force, dir, points, forces, mn = 0) {
        this.conf = conf;
        this.x = x;
        this.y = y;
        this.z = z;
        this.dir = dir;
        this.force = st_force;
        this.split_delay = mn + conf.split_delay_offset + st_force * getRdmFloat(conf.min_split_delay, conf.max_split_delay);

        this.courbe = 0;
        this.points = points;
        this.forces = forces;

    }

    grow = () => {
        if(this.force - this.split_delay <= 0){
            return [{points:this.points, forces:this.forces}];
        }
        const mf = getRdmFloat(this.conf.min_force_de_repartition, this.conf.max_force_de_repartition);
        const f1 = (this.force - this.split_delay) * (mf+ this.conf.main_keep);
        const f2 = (this.force - this.split_delay) * (1-mf);

        for (let i = 1; i <= this.conf.detail; i++) {
            this.x += this.conf.step * this.dir.x * (this.split_delay/this.conf.detail);
            this.y += this.conf.step * this.dir.y * (this.split_delay/this.conf.detail);
            this.z += this.conf.step * this.dir.z * (this.split_delay/this.conf.detail);
            this.points.push(new THREE.Vector3(this.x, this.y, this.z));
            this.forces.push(this.conf.min_radius + (this.force - (i*(this.force-f1)/this.conf.detail)) * this.conf.radius);
        }



        const da1 = getRdmFloat(this.conf.min_angle_de_separation, this.conf.max_angle_de_separation);
        const ma1 = getRdmFloat(this.conf.min_maintient_de_la_branche_mere, this.conf.max_maintient_de_la_branche_mere);
        const da2 = getRdmFloat(0, Math.PI*2);

        const d1 = this.dir.clone();
        const d2 = this.dir.clone();

        let vec_dir;

        if(this.dir.z !== 0){
            vec_dir = new THREE.Vector3(0, 0, this.dir.z);
        }else if(this.dir.y !== 0){
            vec_dir = new THREE.Vector3(0,  this.dir.y, 0);
        }else{
            vec_dir = new THREE.Vector3(this.dir.x, 0, 0);
        }

        if(vec_dir.equals(this.dir)){
            vec_dir = new THREE.Vector3(this.dir.y, this.dir.z, this.dir.x);
        }else{
            vec_dir.cross(this.dir);
        }

        d1.applyAxisAngle(vec_dir.normalize(), -da1 * ma1);
        d1.applyAxisAngle(this.dir, da2);

        d2.applyAxisAngle(vec_dir.normalize(), da1 * (1-ma1));
        d2.applyAxisAngle(this.dir, da2);

        const sub_branch_1 = new Branch(this.conf, this.x,this.y,this.z, f1, d1, this.points, this.forces);
        const sub_branch_2 = new Branch(this.conf, this.x,this.y,this.z, f2, d2, [new THREE.Vector3(this.x, this.y, this.z)],
            [this.conf.min_radius + f2 * this.conf.radius]);
        return [...(sub_branch_1.grow()), ...(sub_branch_2.grow())];
    }
}




